import type { BaseProfile } from '@/core/models/member/user.model'
import { defineStore } from 'pinia'
import { ref } from 'vue'

// 定义 Store
export const useUserStore = defineStore(
  'member',
  () => {
    // 会员信息
    const profile = ref<BaseProfile>()

    // 保存会员信息，登录时使用
    const setProfile = (val: AnyObject) => {
      profile.value = {
        uid: val.uid,
        user_headimg: val?.user_headimg,
        user_avatar: val?.user_avatar,
        wx_headimg: val?.wx_headimg,
        user_name: val?.user_name,
        nick_name: val?.nick_name,
        user_email: val?.user_email,
        user_tel: val?.user_tel,
        token: val.token,
        tencent_user_id: val?.tencent_user_id,
        preEnv: import.meta.env.MODE,
      }
    }

    // 清理会员信息，退出时使用
    const clearProfile = () => {
      profile.value = undefined
      wxInfo.value = {}
      wxCode.value = null
    }

    // 微信登录相关信息
    const wxCode = ref()
    const wxInfo = ref<AnyObject>({})
    const setWxInfo = (val: AnyObject) => {
      wxInfo.value.openid = val.applet_openid
      wxInfo.value.unionid = val.applet_unionid
    }

    // 是否登录
    const isLogin = (isgo = false): boolean => {
      const isLogin = !!profile.value?.token
      if (!isLogin) {
        if (isgo) {
          uni.navigateTo({
            url: '/me/passport/login',
          })
        }
        return false
      }
      return true
    }

    const statusBarHeight = ref(0)
    const setStatusBarHeight = (val: number) => {
      statusBarHeight.value = val
    }

    // 是否刷新团购页面数据 grouponList-订单列表 orderDetail-订单详情 evaluateList-评论列表
    const isRefreshGrouponData: any = ref({
      val: false,
      type: '',
    })
    const setIsRefreshGrouponData = (val: boolean, type: string = '') => {
      isRefreshGrouponData.value.val = val
      isRefreshGrouponData.value.type = type
    }

    // 获取点击页面坐标数据
    const pegePositionData: any = ref({
      pageX: '',
      pageY: '',
    })
    const setPegePositionData = (x: number, y: number) => {
      pegePositionData.value.pageX = x
      pegePositionData.value.pageY = y
    }

    // 记得 return
    return {
      profile,
      wxInfo,
      wxCode,
      statusBarHeight,
      isRefreshGrouponData,
      pegePositionData,
      setProfile,
      clearProfile,
      isLogin,
      setWxInfo,
      setStatusBarHeight,
      setIsRefreshGrouponData,
      setPegePositionData,
    }
  },
  {
    // 网页端配置
    // #ifdef H5
    persist: true,
    // #endif
    // 小程序端配置
    // #ifndef H5
    persist: {
      storage: {
        getItem(key) {
          return uni.getStorageSync(key)
        },
        setItem(key, value) {
          uni.setStorageSync(key, value)
        },
      },
    },
    // #endif
  },
)
